import { LogManager } from 'aurelia-framework';

export function log(level: 'debug' | 'info' | 'warn' | 'error' = 'info', loggerId = '@log', logArgs = false) {
  return (target, propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalFunction = descriptor.value;
    descriptor.value = function (...args: unknown[]) {
      const logger = LogManager.getLogger(loggerId);
      const message = `${target.constructor.name}.${propertyKey}(${args.length > 0 ? '...' : ''})`;
      logArgs ? logger[level](message, ...args) : logger[level](message);
      return originalFunction.apply(this, args);
    }
  }
}

export function delay(ms: number) {
  return (target, propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalFunction = descriptor.value;
    descriptor.value = async function (...args: unknown[]) {
      await new Promise(resolve => setTimeout(resolve, ms));
      return originalFunction.apply(this, args);
    }
  }
}

export function throwError(probability = 1) {
  return (target, propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalFunction = descriptor.value;
    descriptor.value = function (...args: unknown[]) {
      if (Math.random() < probability)
        throw Error(`${target.constructor.name}.${propertyKey} thrown a test error. Review error handling.`);
      return originalFunction.apply(this, args);
    }
  }
}
